import { engineeringClassificationConstants } from "../constants";

const initState = {
  list: {}
};

export const engineeringClassifications = (state = initState, action) => {
  switch (action.type) {
    case engineeringClassificationConstants.GET_LIST_REQUEST:
      return {
        ...state,
        list: {
          loading: true,
          listItems: null,
          getListFail: null
        }
      };
    case engineeringClassificationConstants.GET_LIST_SUCCESS:
      return {
        ...state,
        list: {
          loading: false,
          listItems: action.engineeringClassficiations,
          getListFail: null
        }
      };
    case engineeringClassificationConstants.GET_LIST_FAILURE:
      return {
        ...state,
        list: {
          loading: false,
          listItems: null,
          getListFail: action.error
        }
      };
    case engineeringClassificationConstants.RESET_LIST_SUCCESS:
      return {
        ...state,
        list: {}
      };
    default:
      return state;
  }
};
